angular.module( 'acme.view.application.templates.modals.published', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.templates.modals.published.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var templatesModalsPublished = {
        name: 'application.templates.modals.published',
        url: '/templates/modals/published',
        views: {
          "main": {
            controller: 'TemplatesModalsPublishedController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/templates/modals/published/published.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(templatesModalsPublished);
});
